// dependencies
import React from "react";

import { faExternalLink } from "@fortawesome/pro-duotone-svg-icons";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import { Avatar } from "@performyard/py-components";

// styles
import css from "../AddFormModal.module.scss";

type AuthorResultProps = {
	authorID: string;
	authorName: string;
	failedReason?: string;
	openLink?: string;
};

const AuthorResult: React.FC<AuthorResultProps> = ({ authorID, authorName, failedReason, openLink }) => {
	return (
		<div className={css.resultAuthor}>
			<Avatar dangerouslySetClassName={css.resultAvatar} size={16} id={authorID} alt={`${authorName}'s avatar`} />

			<div className={css.resultAuthorName}>
				{authorName}

				{failedReason ? (
					<div className={`${css.helperIcon} ${css.failedReason} ${css.tooltip}`}>
						<FontAwesomeIcon data-testid="circle-info" icon={faInfoCircle} />
						<span>{failedReason}</span>
					</div>
				) : null}

				{openLink ? (
					<div className={`${css.helperIcon} ${css.openLinkIcon}`}>
						<a href={openLink} target="_blank" rel="noopener noreferrer">
							<FontAwesomeIcon data-testid="arrow-up-right-from-square" icon={faExternalLink} />
						</a>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default AuthorResult;
